import React, { useEffect, useState } from "react";
import { auth } from "../firebaseConfig";
import { FaFilePdf } from "react-icons/fa";
import { FaCheckCircle, FaTimesCircle, FaClock } from "react-icons/fa";
import "../App.css";

const CuentaCorriente = () => {
  const [proveedor, setProveedor] = useState("");
  const [cuit, setCuit] = useState("");
  const [estadoFiltro, setEstadoFiltro] = useState("Todos");
  const [fechaDesdeFiltro, setFechaDesdeFiltro] = useState("");
  const [fechaHastaFiltro, setFechaHastaFiltro] = useState("");
  const [datos, setDatos] = useState([]);
  const [filtrados, setFiltrados] = useState([]);

  useEffect(() => {
    const fetchProveedorYCabeceras = async () => {
      try {
        const user = auth.currentUser;
        if (!user) return;

        // Obtener proveedor y CUIT
        const proveedorRes = await fetch(`/api/get-proveedor?email=${user.email}`);
        const proveedorData = await proveedorRes.json();
        if (proveedorData.proveedor) {
          setProveedor(proveedorData.proveedor);
        }

        const cuit = localStorage.getItem("cuit");
        setCuit(cuit);

        // Obtener cabeceras combinadas (CAB_S + CAB_I) 
        const res = await fetch(`/api/getCuentaCorriente?cuit=${cuit}`);
        const allData = await res.json();

        const ESTADOS_MAP = {
          "Pendiente": "Pendiente",
          "Listo para exportar": "En Proceso",
          "Exportado": "Aprobada",
          "Rechazada": "Rechazada",
          "Sin Detalles": "Rechazada"
        };

        const mapeados = allData.map((item) => ({
          ...item,
          estado: ESTADOS_MAP[item.estado] || item.estado
        }));

        setDatos(mapeados);
        setFiltrados(mapeados);

      } catch (err) {
        console.error("❌ Error cargando cuenta corriente:", err);
      }
    };

    fetchProveedorYCabeceras();
  }, []);

  useEffect(() => {
    let filtered = [...datos];
  
    if (estadoFiltro !== "Todos") {
      filtered = filtered.filter((item) => item.estado === estadoFiltro);
    }
  
    if (fechaDesdeFiltro && fechaHastaFiltro) {
      filtered = filtered.filter((item) => {
        const fecha = new Date(item.fecha);
        const fechaDesde = new Date(fechaDesdeFiltro);
        const fechaHasta = new Date(fechaHastaFiltro);
        return fecha >= fechaDesde && fecha <= fechaHasta;
      });
    }
  
    // Ordenar los registros por fecha de emisión (descendente)
    filtered.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
  
    setFiltrados(filtered);
  }, [estadoFiltro, fechaDesdeFiltro, fechaHastaFiltro, datos]);
  
  return (
    <div className="cuenta-corriente-container">
      <h2>Cuenta Corriente</h2>
      <p><strong>Proveedor:</strong> {proveedor}</p>
      <p><strong>CUIT:</strong> {cuit}</p>

      <div className="headerform-container">
        <div className="filtros">
          <label>
            Estado:
            <select value={estadoFiltro} onChange={(e) => setEstadoFiltro(e.target.value)}>
              <option value="Todos">Todos</option>
              <option value="Pendiente">Pendiente</option>
              <option value="Aprobada">Aprobada</option>
              <option value="Rechazada">Rechazada</option>
            </select>
          </label>

          <label>
            Fecha Desde:
            <input
              type="date"
              value={fechaDesdeFiltro}
              onChange={(e) => setFechaDesdeFiltro(e.target.value)}
            />
          </label>

          <label>
            Fecha Hasta:
            <input
              type="date"
              value={fechaHastaFiltro}
              onChange={(e) => setFechaHastaFiltro(e.target.value)}
            />
          </label>
        </div>
      </div>

      <table className="details-table">
        <thead>
          <tr>
            <th>Factura</th>
            <th>Tipo</th>
            <th>Fecha Emisión</th>
            <th>Monto</th>
            <th>Moneda</th>
            <th>Estado</th>
            <th>N° O. Pago</th>
            <th>Orden Pago</th>
            <th>Comentarios</th>
          </tr>
        </thead>
        <tbody>
            {filtrados.length > 0 ? (
                filtrados.map((item, index) => (
                <tr
                    key={index}
                    className={
                    item.estado === "Aprobada"
                        ? "fila-aprobada"
                        : item.estado === "Rechazada"
                        ? "fila-rechazada"
                        : ""
                    }
                >
                    <td>{item.nroFactura}</td>
                    <td>{item.tipo}</td>
                    <td>{item.fecha}</td>
                    <td>${item.monto}</td>
                    <td>{item.moneda}</td>
                    <td>
                      {item.estado === "Aprobada" && (
                        <>
                          <FaCheckCircle style={{ color: "#2e7d32", marginRight: "5px" }} />
                          <span style={{ color: "#2e7d32" }}>{item.estado}</span>
                        </>
                      )}
                      {item.estado === "Rechazada" && (
                        <>
                          <FaTimesCircle style={{ color: "#c62828", marginRight: "5px" }} />
                          <span style={{ color: "#c62828" }}>{item.estado}</span>
                        </>
                      )}
                      {item.estado === "Pendiente" && (
                        <>
                          <FaClock style={{ color: "#757575", marginRight: "5px" }} />
                          <span style={{ color: "#757575" }}>{item.estado}</span>
                        </>
                      )}
                      {!["Aprobada", "Rechazada", "Pendiente"].includes(item.estado) && item.estado}
                    </td>

                    <td>{item.nroOrdenPago || "-"}</td>
                    <td>
                    {item.linkOrdenPago ? (
                        <a href={item.linkOrdenPago} target="_blank" rel="noopener noreferrer">
                        <FaFilePdf size={18} color="#d32f2f" />
                        </a>
                    ) : (
                        "-"
                    )}
                    </td>
                    <td>{item.comentario || "-"}</td>
                </tr>
                ))
            ) : (
                <tr>
                <td colSpan="9">No hay resultados para mostrar.</td>
                </tr>
            )}
            </tbody>
      </table>
    </div>
  );
};

export default CuentaCorriente;



